import { render, staticRenderFns } from "./Gratification.vue?vue&type=template&id=486b338e&scoped=true&"
import script from "./Gratification.vue?vue&type=script&lang=js&"
export * from "./Gratification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486b338e",
  null
  
)

export default component.exports